import { createFileRoute } from '@tanstack/react-router';

import { OperationChecksEditor } from '../../features/operations/operation-checks-editor';
import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { operationBreadcrumbBadges } from '../../features/operations/operation-route-chrome';
import { operationDetailQueryOptions } from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id_/checks')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data ? `${data.operation_name} — Checks` : 'Operation Checks';
    },
    breadcrumbBadges: operationBreadcrumbBadges,
    layout: 'full-height',
  },
  component: OperationChecksPage,
});

function OperationChecksPage() {
  const { operation_id: operationId } = Route.useParams();

  return (
    <OperationDetailShell operationId={operationId} active="checks">
      {(operation, partnerId) => (
        <OperationChecksEditor
          key={operation.operation_id}
          operation={operation}
          partnerId={partnerId}
        />
      )}
    </OperationDetailShell>
  );
}
